/** Firestore doc ids under `users/{uid}/private/{doc}`. */
export const PLAYER_SAVE_DOC_CHARACTER = "playerCharacter";
export const PLAYER_SAVE_DOC_GAME_STATE = "playerGameState";
export const PLAYER_SAVE_DOC_HOME = "playerHome";
export const PLAYER_SAVE_DOC_SKILLS = "playerSkills";

export type PlayerSaveSection = "character" | "gameState" | "home" | "skills";

export const PLAYER_SAVE_SECTIONS: PlayerSaveSection[] = [
  "character",
  "gameState",
  "home",
  "skills",
];

export function playerSaveDocId(section: PlayerSaveSection): string {
  switch (section) {
    case "character":
      return PLAYER_SAVE_DOC_CHARACTER;
    case "gameState":
      return PLAYER_SAVE_DOC_GAME_STATE;
    case "home":
      return PLAYER_SAVE_DOC_HOME;
    case "skills":
      return PLAYER_SAVE_DOC_SKILLS;
  }
}
